import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import MaleHoldingMagnifingGlass from '../../../../../assets/svgs/male-holding-magnifying-glass';
import Compass from '../../../../../assets/svgs/compass';
import { Flex } from '@magnetic/flex';
import { useTranslation } from 'react-i18next';
const StyledResetView = styled(Flex) `
  position: fixed;
  transform: translate(-50%, -50%);
  z-index: 99999;

  .reset-modal {
    background-color: #000;
    opacity: 1;

    position: fixed;
    z-index: 9;
    width: 100vw;
    height: 100vh;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.7);

    .reset-modal-content {
      background-color: #fefefe;
      margin: 15% auto;
      padding: 2vw;
      width: 56%;
      background: #2b3746;
      box-sizing: border-box;
      border-radius: 0.6vw;
      transform: scale(0.72);
      .icon {
      }
      .header {
        color: #ffffff;
        font-size: 2.5vw;
        line-height: 5vw;
      }
      .subtext {
        color: #ffffff;
        font-size: 1.2vw;
        padding-top: 1vw;
        line-height: 1.9vw;
      }
      .circle {
        width: 100%;
        height: 100%;

        -moz-border-radius: 50%;
        -webkit-border-radius: 50%;
        border-radius: 50%;
      }
      .circle.one {
        --color: ${(props) => (props.counter > 0 ? '#00bceb' : '#26282b')}
          --p: ${(props) => props.counter > 0 ? (props.counter / props.maxTime) * 100 : 0};
        --v: calc(((18 / 5) * var(--p) - 90) * 1deg);
        width: 10vw;
        height: 10vw;
        background:
          linear-gradient(#26282b, #26282b) content-box,
          linear-gradient(var(--v), #26282b 50%, transparent 0) 0 /
            min(100%, (50 - var(--p)) * 100%),
          linear-gradient(var(--v), transparent 50%, var(--color) 0) 0 /
            min(100%, (var(--p) - 50) * 100%),
          linear-gradient(to right, #26282b 50%, var(--color) 0);
        padding: 0.3125vw;
        border: 1px solid #383b3d;
      }
      .countdown {
        padding-top: 1.15vw;
      }
      .circle.two {
        border: 1px solid #383b3d;
        text-align: center;
      }
      .counter {
        font-family: 'CiscoSans';
        padding-top: 3.7vw;
        font-style: normal;
        font-weight: 400;
        font-size: 40px;
        line-height: 39px;
        text-align: center;
        color: #ffffff;
      }
      .reset-in {
        font-size: 18px;
        line-height: 1vw;
        font-size: 1vw;
        margin-top: -1vw;
        color: #ffffff;
        margin-bottom: 1vw;
        padding-left: 1vw;
      }

      button {
        font-family: 'CiscoSansTT Heavy';
        text-align: center;
        width: 12vw;
        font-size: 1.5vw;
        border: none;
        margin: 0 2vw;
        padding: 0.6vw 0;
      }

      .button-continue {
        background: linear-gradient(180deg, #6abf4b 0%, #34711e 100%);
        border-radius: 0.6vw;
        font-size: 1.25vw;
        color: #ffffff;
        height: 4vw;
      }
      .button-reset {
        background: linear-gradient(180deg, #1d7ff3 0%, #113d7d 100%);
        border-radius: 0.6vw;
        font-size: 1.25vw;
        color: #ffffff;
        height: 4vw;
      }
      .reset-text {
        padding-left: 1vw;
        font-family: 'CiscoSans';
      }
      .reset-icon {
        vertical-align: sub;
      }
      .continue-text {
        vertical-align: sub;
        font-family: 'CiscoSans';
      }
    }

    /* The Close Button */
    .close {
      float: right;
      font-weight: bold;
    }

    .close:hover,
    .close:focus {
      color: #aaa;
      text-decoration: none;
      cursor: pointer;
    }
  }

  .arc {
    --b: 16px; /* the boder thickness */
    --a: ${(props) => 360 - props.degree}deg; /* control the progression */

    width: 8vw;
    aspect-ratio: 1;
    padding: var(--b);
    border-radius: 50%;
    background: linear-gradient(180deg, #1d7ff3 0%, #113d7d 100%);
    --_g: /var(--b) var(--b) no-repeat radial-gradient(50% 50%, #000 97%, #0000);
    mask:
      top var(--_g),
      calc(50% + 50% * sin(var(--a))) calc(50% - 50% * cos(var(--a))) var(--_g),
      linear-gradient(#0000 0 0) content-box intersect,
      conic-gradient(#000 var(--a), #0000 0);
  }
`;
export default function InactivityPopup({ continueHandler, resetViewHandler, maxTime = 30, }) {
    const intervalRef = useRef(null);
    const [counter, setCounter] = useState(maxTime);
    const { t } = useTranslation();
    useEffect(() => {
        if (counter === 0) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
            resetViewHandler();
        }
    }, [counter]);
    useEffect(() => {
        if (intervalRef.current === null) {
            intervalRef.current = setInterval(() => {
                setCounter((counter) => counter - 1);
            }, 1000);
        }
    }, []);
    return (_jsx(StyledResetView, Object.assign({ counter: counter, maxTime: maxTime, degree: 360 - counter * (360 / maxTime) }, { children: _jsx("div", Object.assign({ className: "reset-modal" }, { children: _jsxs("div", Object.assign({ className: "reset-modal-content" }, { children: [_jsxs(Flex, Object.assign({ style: { border: '12px solid #252d36', borderRadius: '0.6vw' } }, { children: [_jsx("div", Object.assign({ className: "columns medium-2" }, { children: _jsx(MaleHoldingMagnifingGlass, {}) })), _jsxs("div", Object.assign({ className: "columns medium-6", style: { marginLeft: '4vw' } }, { children: [_jsx("div", Object.assign({ className: "header" }, { children: t('floor.inactive.popup.label1') })), _jsx("div", Object.assign({ className: "subtext" }, { children: t('floor.inactive.popup.label2') }))] })), _jsxs("div", Object.assign({ className: "columns medium-2 countdown", style: { margin: '1vw' } }, { children: [_jsx("div", Object.assign({ className: "reset-in" }, { children: t('floor.inactive.popup.label3') })), _jsx("div", Object.assign({ className: "circle one" }, { children: _jsxs("div", Object.assign({ className: "circle two" }, { children: [_jsx("div", Object.assign({ className: "arc" }, { children: " " })), _jsx("div", Object.assign({ className: "counter", style: {
                                                        marginTop: window.innerHeight > window.innerWidth
                                                            ? '-10.2vw'
                                                            : '-9.2vw',
                                                    } }, { children: counter }))] })) }))] }))] })), _jsxs(Flex, Object.assign({ justify: "center", style: {
                            marginTop: '4vw',
                            position: 'absolute',
                            width: '31vw',
                            marginLeft: '18%',
                            padding: '1vw 0',
                            borderRadius: '0.6vw',
                            background: '#1f2226',
                        } }, { children: [_jsx("div", Object.assign({ className: "columns medium-3" }, { children: _jsx("button", Object.assign({ className: "button-continue", onClick: () => {
                                        continueHandler();
                                    } }, { children: _jsx("span", Object.assign({ className: "continue-text" }, { children: t('floor.inactive.popup.continue') })) })) })), _jsx("div", Object.assign({ className: "columns medium-3 margin-right" }, { children: _jsxs("button", Object.assign({ className: "button-reset", onClick: () => {
                                        resetViewHandler();
                                    } }, { children: [_jsx("span", Object.assign({ className: "reset-icon" }, { children: _jsx(Compass, {}) })), _jsx("span", Object.assign({ className: "reset-text" }, { children: t('floor.inactive.popup.reset-view') }))] })) }))] }))] })) })) })));
}
